import { collectOrgIdsForAnyOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { intersection } from '../../../utils';
export const orgHasAccess = (userState, permissions, permissionType) => {
    var _a, _b, _c, _d, _e, _f;
    const orgIds = [...((_b = (_a = permissions[permissionType]) === null || _a === void 0 ? void 0 : _a.organizationIds) !== null && _b !== void 0 ? _b : [])];
    if (permissionType === 'read') {
        orgIds.push(...((_d = (_c = permissions['write']) === null || _c === void 0 ? void 0 : _c.organizationIds) !== null && _d !== void 0 ? _d : []));
        orgIds.push(...((_f = (_e = permissions['modify']) === null || _e === void 0 ? void 0 : _e.organizationIds) !== null && _f !== void 0 ? _f : []));
    }
    const uniqueOrgIds = Array.from(new Set(orgIds));
    const rights = permissionType === 'read' ? ['manage-documents', 'view-documents'] : ['manage-documents'];
    return (!!(uniqueOrgIds === null || uniqueOrgIds === void 0 ? void 0 : uniqueOrgIds.length) &&
        intersection(uniqueOrgIds, userState.orgMembership) &&
        intersection(uniqueOrgIds, collectOrgIdsForAnyOrgPermission(userState, ...rights)));
};
